import { createFeature, createReducer, on } from '@ngrx/store';
import { AuthState } from '../../../core/models/auth.model';
import { AuthActions } from './auth.actions';

const initialState: AuthState = {
  token: null,
  refreshToken: null,
  userName: null,
  role: null,
  publicId: null,
  permissions: [],
  userType: null,
  roles: [],
  loading: false,
  error: null,
  forgotPasswordLoading: false,
  forgotPasswordMessage: null,
  forgotPasswordError: null,
};

export const authFeature = createFeature({
  name: 'auth',
  reducer: createReducer(
    initialState,
    on(AuthActions.login, (state) => ({ ...state, loading: true, error: null })),
    on(
      AuthActions.loginSuccess,
      (state, { token, refreshToken, userName, role, publicId, permissions }) => ({
        ...state,
        token,
        refreshToken,
        userName,
        role,
        publicId,
        permissions,
        loading: false,
        error: null,
      }),
    ),
    on(AuthActions.loginFailure, (state, { error }) => ({ ...state, loading: false, error })),
    on(AuthActions.tokensRenewed, (state, { token, refreshToken }) => ({
      ...state,
      token,
      refreshToken,
    })),
    on(AuthActions.logout, () => initialState),
    on(AuthActions.sessionExpired, () => initialState),
    on(
      AuthActions.initSuccess,
      (state, { token, refreshToken, userName, role, publicId, permissions, userType, roles }) => ({
        ...state,
        token,
        refreshToken,
        userName,
        role,
        publicId,
        permissions,
        userType,
        roles,
      }),
    ),
    on(AuthActions.loadAccessProfileSuccess, (state, { profile }) => ({
      ...state,
      userType: profile.userType,
      roles: profile.roles,
      permissions: profile.permissions,
    })),
    // A failed refresh must not silently strip a user's existing access
    // mid-session, so the previous userType/roles/permissions are kept.
    on(AuthActions.loadAccessProfileFailure, (state) => state),
    on(AuthActions.forgotPassword, (state) => ({
      ...state,
      forgotPasswordLoading: true,
      forgotPasswordMessage: null,
      forgotPasswordError: null,
    })),
    on(AuthActions.forgotPasswordSuccess, (state, { message }) => ({
      ...state,
      forgotPasswordLoading: false,
      forgotPasswordMessage: message,
      forgotPasswordError: null,
    })),
    on(AuthActions.forgotPasswordFailure, (state, { error }) => ({
      ...state,
      forgotPasswordLoading: false,
      forgotPasswordMessage: null,
      forgotPasswordError: error,
    })),
    on(AuthActions.clearForgotPasswordStatus, (state) => ({
      ...state,
      forgotPasswordLoading: false,
      forgotPasswordMessage: null,
      forgotPasswordError: null,
    })),
  ),
});
